export const oidcConfiguration = {
  client_id: 'repbuilder.front',
  redirect_uri: `${window.location.origin}/authentication/callback`,
  silent_redirect_uri: `${window.location.origin}/authentication/silent-callback`,
  silent_login_uri: `${window.location.origin}/authentication/silent-login`,
  scope:
    'openid profile rvsta_report_layout rvsta_report_render offline_access',
  authority:
    process.env.REACT_APP_AUTHORIZATION_URL ||
    'https://idp.dev.rpt.rvstacor.jp',
  refresh_time_before_tokens_expiration_in_second: 40,
  service_worker_only: false,
  storage: sessionStorage,
  monitor_session: false,
  token_request_extras: {
    client_secret: 'spa_secrets',
    post_logout_redirect_uri:
      `${process.env.REACT_APP_FRONTEND_BASE_URL}/authentication/callback` ||
      `${window.location.origin}/authentication/callback`,
  },
  extras: {},
  token_renew_mode: 'access_token_invalid', // "id_token_invalid" or "access_token_or_id_token_invalid" (default)
};
